import { Fragment, useState } from "react";
import Button from "@mui/material/Button";
import { Col, Row } from "react-bootstrap";
import { axiosPrivate } from "../api/axios";
import { Alert, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";

export default function DocumentUpload({seqno}) {
  const [isUploading, setIsUploading] = useState(false);
  const [errMessage, setErrMessage] = useState('');
  const [done, setDone] = useState(false);
  const [formData, setFormData] = useState({
      File: null,
      ImageUrl: '',
      DocumentType: ''
  });


  const handleFileUpload = async (event) => {
    const fileSelection = event.target.files[0];

    if (fileSelection.size < 2000000) {

      const reader = new FileReader();

      reader.onloadend = () => {
        setFormData((prev) => ({...prev, ImageUrl: reader.result}));
      };

      reader.readAsDataURL(fileSelection);

      setFormData((prev) => ({...prev, File: fileSelection}));
      setErrMessage('');

    } else {

      setFormData({});
      setErrMessage(`Your file is not valid or is too large ${fileSelection.size} bytes`);
    }
  }


  const handleSubmit = (event) => {
    event.preventDefault();

    setIsUploading(true);

    if (!formData.DocumentType) {
      alert("Please select your document type.");
      setErrMessage("Please select your document type.");
      setIsUploading(false)
      return false;
    }

    const seqno = event.target.payment_order.value;
    const file = event.target.payment_advice.files[0];

    const form = new FormData()
    form.append('seqno', seqno);
    form.append('file', file);
    form.append('document_type', formData.DocumentType);

    setTimeout(async () => {
      await axiosPrivate.post('/api/file/upload/payment-advice', form, {
          headers: {
            "Content-Type": "multipart/form-data"
          },
        })
        .then(res => {
          if (res.status === 201) {
            setDone(true);
            setErrMessage('');
          }
        })
        .catch((error) => {
          if (error?.response) {
            setErrMessage(error.response.data);
          } else if (error?.message) {
            setErrMessage(error.message);
          } else {
            console.log(error);
          }
        }).finally(() => {
          setIsUploading(false)
        });
    }, 2000);
  }


  const handleResetForm = () => {
    setDone(false);
    setFormData({});
  }

  return (
    <div className="border rounded p-3 mb-2 document-upload-container">
      <Row>
        <Col>

          <form onSubmit={handleSubmit} encType="multipart/form-data">

            <div className="mb-3">
              <h3 className="h4">Upload a Document for order #{seqno}</h3>
              <p className="text-black-50">If you have already paid for your order, you can upload your payment advice to iStore for fast processing.
                You can also upload your purchase order. Simply select the document type you are uploading.</p>
            </div>

            {done ?
              <Alert severity="success">
                Your {formData.DocumentType} was uploaded successfully for order #{seqno}.<br/>
                <Link onClick={handleResetForm}>Upload Another Document</Link>
              </Alert>
              :
              <Fragment>
                {formData.ImageUrl &&
                  <div className="mb-3 p-3 border rounded text-center">
                    <img 
                      src={formData.ImageUrl}
                      alt={formData.File?.name ? formData.File.name + " (" + formData.File.size + ")" : 'Upload File is Queued'}
                      className="img-fluid"
                      style={{ maxHeight: '200px', height: 'auto' }}
                    />
                  </div>
                }

                <div className="mb-3">
                  {errMessage && <Alert className="mb-3 border" severity="error">{errMessage}</Alert>}
                  
                  {/* Inline Document Type and File Selection */}
                  <div className="row g-2 mb-2">
                    <div className="col-12 col-md-6">
                      <select 
                        name="document_type"
                        className="form-select"
                        value={formData.DocumentType}
                        onChange={(e) => {
                          setFormData((prev) => ({...prev, DocumentType: e.target.value}))
                        }}
                        style={{ minHeight: '48px' }}
                      >
                        <option value="">-- Select Document Type --</option>
                        <option value='Payment Advice'>Electronic Payment Advice</option>
                        <option value='Transport Consignment Note'>Transport Consignment Note</option>
                        <option value='Purchase Order'>Purchase Order</option>
                        <option value='Purchase Order'>RCTI-STC Invoice for Business claim</option>
                      </select>
                    </div>
                    
                    <div className="col-12 col-md-6">
                      <label htmlFor="upload-image" className="mb-0 d-block">
                        <Button 
                          variant="contained" 
                          component="span" 
                          fullWidth
                          sx={{ 
                            minHeight: '48px',
                            fontSize: { xs: '0.875rem', sm: '1rem' }
                          }}
                        >
                          {formData.File ? `Selected: ${formData.File.name}` : 'Choose File'}
                        </Button>
                        <input 
                          id="upload-image" 
                          hidden 
                          type="file" 
                          onChange={handleFileUpload} 
                          name="payment_advice"
                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        />
                        <input 
                          id="upload-order" 
                          hidden 
                          defaultValue={seqno} 
                          name="payment_order"
                        />
                      </label>
                    </div>
                  </div>
                  
                  {/* File size info */}
                  <small className="text-muted">Maximum file size: 2MB. Accepted formats: PDF, JPG, PNG, DOC, DOCX</small>

                  {/* Upload Button */}
                  {formData.File?.size <= 2000000 && formData.DocumentType && (
                    <div className="d-grid gap-2 mt-3">
                      <Button 
                        disabled={isUploading} 
                        color="success" 
                        type="submit" 
                        variant="contained"
                        size="large"
                        sx={{ 
                          minHeight: '48px',
                          fontSize: { xs: '0.875rem', sm: '1rem' }
                        }}
                      >
                        {isUploading ? (
                          <Fragment>
                            <CircularProgress size={20} className="me-2" />
                            Uploading...
                          </Fragment>
                        ) : (
                          'Upload Your File'
                        )}
                      </Button>
                    </div>
                  )}
                </div>
              </Fragment>
            }

          </form>
        </Col>
      </Row>
    </div>
  );
}